import { takeLatest, call, put } from 'redux-saga/effects';

import axiosInstance from '../../services/AuthHeader';
import { setChangePasswordResult } from '../reducers/authorization';
import { setSending, unsetSending } from '../reducers/serverCommunication';

export const SAGA_SEND_CHANGE_PASSWORD = 'SAGA_SEND_CHANGE_PASSWORD';

export function sendChangePasswordSaga(oldPassword, newPassword) {
  const payload = { oldPassword: oldPassword, newPassword: newPassword };
  return { type: SAGA_SEND_CHANGE_PASSWORD, payload };
}

const handleChangePassword = async ({ oldPassword, newPassword }) =>
  axiosInstance
    .post('/api/auth/changePassword', { oldPassword, newPassword })
    .then((res) => res.data);

export function* sendChangePassword(action) {
  yield put(setSending);
  try {
    yield call(handleChangePassword, action.payload);
    yield put(setChangePasswordResult(true));
  } catch (e) {
    yield put(setChangePasswordResult(false, e?.response?.data?.message));
  } finally {
    yield put(unsetSending);
  }
}

export function* watchForSendChangePassword() {
  yield takeLatest(SAGA_SEND_CHANGE_PASSWORD, sendChangePassword);
}
